import { render, staticRenderFns } from "./HeaderNormal.vue?vue&type=template&id=afdaf096&scoped=true"
import script from "./HeaderNormal.vue?vue&type=script&lang=js"
export * from "./HeaderNormal.vue?vue&type=script&lang=js"
import style0 from "./HeaderNormal.vue?vue&type=style&index=0&id=afdaf096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdaf096",
  null
  
)

export default component.exports